import { useState } from 'react';
// mui //
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
// third party libraries //
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// components //
import ErrorStatus from 'utils/constants';
import Alert from './Alert';

const ExtendedSnackbar = () => {
  const navigate = useNavigate();
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);

  axios.interceptors.request.use(
    (request) => request,
    (error) => {
      if (error?.response?.data?.message) {
        setOpen(true);
        setSeverity('error');
        setMessage(error?.response?.data?.message);
      }
      return Promise.reject(error);
    },
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        if (error.response?.status) {
          const { status } = error.response;
          if (status === ErrorStatus.NOT_FOUND
            || status === ErrorStatus.NOT_AUTHORIZED
            || status === ErrorStatus.FORBIDDEN_ERROR
            || status === ErrorStatus.LEGAL_REASON_UNAVAILABLE) {
            navigate(`/error/${status}`);
          } else {
            let messageError = error.response?.data?.message;
            const type = error.response?.data?.severity;
            if (messageError) {
              setOpen(true);
              setSeverity(type || 'error');
              setMessage(messageError);
            } else {
              messageError = 'Lo sentimos, pero no podemos procesar su solicitud en este momento. Póngase en contacto con el equipo de soporte.';
              if (status === ErrorStatus.GATEWAY_TIMEOUT || status === ErrorStatus.NETWORK_ERROR) {
                messageError = 'Lo sentimos, estamos experimentando retrasos en el procesamiento de su solicitud. Póngase en contacto con el equipo de soporte.';
              }
              setOpen(true);
              setSeverity(type || 'error');
              setMessage(messageError);
            }
          }
        } else if (error?.response?.data?.message) {
          setOpen(true);
          setSeverity('error');
          setMessage(error?.response?.data?.message);
        }
      }

      return Promise.reject(error);
    },
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar
        open={open}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default ExtendedSnackbar;
